import type {
  AppealStatus,
  IncidentCategory,
  IncidentSeverity,
  IncidentStatus,
  ModerationStatus,
  ProposalSource,
  ProposalStatus,
} from "../types";

export const MODERATION_STATUS_LABELS: Record<ModerationStatus, string> = {
  NONE: "Sin acción",
  UNPUBLISHED: "Despublicado",
  FROZEN: "Ventas pausadas",
  CANCELED: "Cancelado",
  BANNED: "Baneado",
};

export const INCIDENT_CATEGORY_LABELS: Record<IncidentCategory, string> = {
  violence: "Violencia",
  weapons_drugs: "Armas / drogas",
  theft: "Robo",
  sexual_abuse: "Abuso sexual",
  drunk_aggressive: "Ebriedad agresiva",
  unpaid: "Impago",
  misconduct: "Mala conducta",
  other: "Otro",
};

export const GRAVE_CATEGORIES: IncidentCategory[] = [
  "violence",
  "weapons_drugs",
  "theft",
  "sexual_abuse",
];

export function isGraveCategory(c: IncidentCategory | null | undefined): boolean {
  return !!c && GRAVE_CATEGORIES.includes(c);
}

export const INCIDENT_STATUS_LABELS: Record<IncidentStatus, string> = {
  resolved_on_site: "Resuelto en sitio",
  pending_identification: "Pendiente identificación",
  resolved_post_event: "Resuelto post-evento",
  revoked: "Anulado",
};

export const INCIDENT_SEVERITY_LABELS: Record<IncidentSeverity, string> = {
  low: "Leve",
  high: "Grave",
};

export const PROPOSAL_STATUS_LABELS: Record<ProposalStatus, string> = {
  pending_review: "Pendiente revisión",
  approved: "Aprobado",
  rejected: "Rechazado",
  requested_more_info: "Pidió más info",
};

export const PROPOSAL_SOURCE_LABELS: Record<ProposalSource, string> = {
  manual: "Manual",
  auto_reincidence: "Reincidencia automática",
};

export const APPEAL_STATUS_LABELS: Record<AppealStatus, string> = {
  pending: "Pendiente",
  approved_revoke: "Aprobada (ban revocado)",
  rejected: "Rechazada",
};

export function moderationStatusTone(s: ModerationStatus): "neutral" | "info" | "success" | "warning" | "danger" {
  switch (s) {
    case "NONE":
      return "neutral";
    case "UNPUBLISHED":
      return "info";
    case "FROZEN":
      return "warning";
    case "CANCELED":
    case "BANNED":
      return "danger";
  }
}

export function proposalStatusTone(s: ProposalStatus): "neutral" | "info" | "success" | "warning" | "danger" {
  switch (s) {
    case "pending_review":
      return "warning";
    case "approved":
      return "success";
    case "rejected":
      return "danger";
    case "requested_more_info":
      return "info";
  }
}

export function appealStatusTone(s: AppealStatus): "neutral" | "info" | "success" | "warning" | "danger" {
  switch (s) {
    case "pending":
      return "warning";
    case "approved_revoke":
      return "success";
    case "rejected":
      return "danger";
  }
}

export function incidentStatusTone(s: IncidentStatus): "neutral" | "info" | "success" | "warning" | "danger" {
  switch (s) {
    case "resolved_on_site":
    case "resolved_post_event":
      return "success";
    case "pending_identification":
      return "warning";
    case "revoked":
      return "neutral";
  }
}
